var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-home"},[_c('div',{staticClass:"ma-title"},[_c('h2',[_c('Icon',{attrs:{"type":"home","large":"","light":""}}),_vm._v(" Home ")],1)]),(_vm.isStudent)?_c('StudentHome'):_vm._e(),(_vm.isTeacher)?_c('TeacherHome'):_vm._e(),(!_vm.isStudent && !_vm.isTeacher)?_c('PublicHome'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }